import { render, staticRenderFns } from "./Nee_ScreenSubir.vue?vue&type=template&id=70c56680"
import script from "./Nee_ScreenSubir.vue?vue&type=script&lang=js"
export * from "./Nee_ScreenSubir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports